let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6W3yJ")).then(() => parcelRequire('7EEt8'));